import * as buttons from 'smg/buttons';
import { UpdateUser } from 'smg/customer-api/v2/users';
import * as session from 'smg/customer-api/session';
import * as errors from 'smg/errors';
import { ReportValidity } from 'smg/form';
import * as phone from 'smg/phone';
import * as template from 'smg/template';
import { AccountReady } from '../account-session';

void main();

async function main() {
    if (await AccountReady) {
        return;
    }

    const formParent = document.querySelector('#form-parent') as HTMLElement;
    const form = document.querySelector('#account-settings-form') as HTMLFormElement;
    const fieldset = form.querySelector('fieldset') as HTMLFieldSetElement;
    const submit = form.querySelector('[type="submit"]') as HTMLButtonElement;
    const formSpinner = document.querySelector('#form-spinner') as HTMLElement;

    const userID = document.querySelector('#user-id') as HTMLElement;

    const sess = await session.Session();

    userID.textContent = sess.user.id ?? '';

    formSpinner.parentElement?.removeChild(formSpinner);
    formParent.classList.remove('d-none');

    const firstName = document.querySelector('#first-name') as HTMLInputElement;
    const lastName = document.querySelector('#last-name') as HTMLInputElement;
    const company = document.querySelector('#company') as HTMLInputElement;
    const email = document.querySelector('#email') as HTMLInputElement;
    const phoneEl = document.querySelector('#phone') as HTMLInputElement;

    firstName.value = sess.user.firstName ?? '';
    lastName.value = sess.user.lastName ?? '';
    company.value = sess.user.company ?? '';
    email.value = sess.user.emailAddress.email;
    phoneEl.value = sess.user.phoneNumber.phone;

    if (firstName.value) {
        firstName.required = true;
    }
    if (lastName.value) {
        lastName.required = true;
    }
    if (phoneEl.value) {
        phoneEl.required = true;
    }

    const p = new phone.Input(phoneEl);

    const alertParent = document.querySelector('#alert-parent') as HTMLElement;

    form.noValidate = true;
    form.addEventListener('submit', async e => {
        e.preventDefault();

        if (!ReportValidity(form)) {
            return false;
        }

        fieldset.disabled = true;
        buttons.Start(submit);

        UpdateUser(sess.user.id, {
            firstName: firstName.value,
            lastName: lastName.value,
            company: company.value,
            email: email.value,
            phone: await p.format(),
        }, ['id']).then(() => {
            session.ClearCache();
            alertParent.appendChild(template.Clone('#update-success-template'));
        }).catch(err => errors.ShowError(err, form)).
            finally(() => {
                fieldset.disabled = false;
                buttons.Stop(submit);
            });
    });
}